<template>

  <v-card class="pa-5">
    <v-row>
      <v-col cols="12" md="6">

        <div class="d-flex align-center">
          <!-- Icon -->
          <v-avatar color="green lighten-4" size="44">
            <v-icon color="green darken-2">mdi-bell-ring</v-icon>
          </v-avatar>

          <!-- Title + Toggle -->
          <div class="ml-4 flex-grow-1">
            <div class="ml-4 d-flex align-center flex-wrap">
              <h3 class="font-weight-medium mb-0 mr-3">
                Enable Notification Template Customization
              </h3>
              <v-switch v-model="settings.notification_customization" color="primary" hide-details
                class="input_switch mt-0"></v-switch>
            </div>

            <!-- Description -->
            <p class="ml-4 mt-2 mb-0 text--secondary">
              Allow company owners to customize email notification templates settings for their courses and updates.
            </p>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6">
      <div class="d-flex align-center">
          <!-- Icon -->
          <v-avatar color="green lighten-4" size="44">
            <v-icon color="green darken-2">mdi-palette</v-icon>
          </v-avatar>

          <!-- Title + Toggle -->
          <div class="ml-4 flex-grow-1">
            <div class="ml-4 d-flex align-center flex-wrap">
              <h3 class="font-weight-medium mb-0 mr-3">
                Enable Theme Color Customization
              </h3>
              <v-switch v-model="settings.theme_customization" color="primary" hide-details
                class="input_switch mt-0"></v-switch>
            </div>

            <!-- Description -->
            <p class="ml-4 mt-2 mb-0 text--secondary">
              Allow company owners to customize theme colors to match their brand identity and preferences.
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="text-center mt-8">
       <v-btn v-if="loading" color="primary" loading></v-btn>
      <v-btn
        color="primary"
        large
        elevation="2"
        @click="saveCompanySettings"
        v-else
      >
        <v-icon left>mdi-content-save</v-icon>
        Save Changes
      </v-btn>
      </div>
  </v-card>

</template>

<script>
import companyAPI from '@/api/company.js';

export default {
  name: "SuperAdminCompanyDetails",
  components: {
  },
  props: {
  },
  data() {
    return {
      settings: [],
      companyId: this.$route.params.id,
      loading: false,
      successMessage: 'Company settings successfully updated.',
      errorMessage: 'Oops, something went wrong! Please check information is correct.'
    };
  },
   computed: {
  },
  watch: {
  },
  mounted() {
    this.getCompanySettings();
  },
  methods: {
    getCompanySettings() {
      this.loading = true;
      companyAPI
        .getCompanySettings(this.companyId)
        .then((resp) => {
          this.settings = resp.data.data;
          this.loading = false;
        });
    },
    saveCompanySettings(){
      this.loading = true;
      companyAPI
        .saveCompanySettings(this.companyId,this.settings)
        .then((resp) => {
           this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.loading = false;
        }).catch(err => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
